import {IServiceFactory} from "../../../service-factory.interface";
import {UnaccompaniedMinorBaseSsr} from "./unaccompanied-minor-base-ssr";

export default class UmnrSsrType extends UnaccompaniedMinorBaseSsr {
    constructor(services: IServiceFactory) {
        super('UMNR', services);
    }
}
